import { Link } from 'react-router-dom';
import useSWR from 'swr';
import { useStores } from 'hooks/useStores';
import BreadcrumbJsonLd from 'components/JsonLd/BreadcrumbJsonLd';
import styles from './breadcrumbs.module.scss';

/**
 * type: 'ng' | 'product'
 * slug: slug текущей страницы
 */
const Breadcrumbs = ({ type, slug }) => {
  const { api } = useStores();

  const { data } = useSWR(
    slug ? { type, slug, _key: `breadcrumbs-${type}-${slug}` } : null,
    api.newCatalog.getBreadcrumbs,
    { shouldRetryOnError: false }
  );

  const items = data?.items;

  return (
    <>
      <BreadcrumbJsonLd items={items} />
      {items?.length > 0 && (
        <nav aria-label="Хлебные крошки" className={styles.breadcrumbs}>
          <ol className={styles.list}>
            {items.map((item, idx) => {
              const isLast = idx === items.length - 1;
              return (
                <li key={idx} className={styles.item}>
                  {!isLast ? (
                    <Link to={item.url} className={styles.link}>{item.name}</Link>
                  ) : (
                    <span className={styles.current} aria-current="page">{item.name}</span>
                  )}
                </li>
              );
            })}
          </ol>
        </nav>
      )}
    </>
  );
};

export default Breadcrumbs;
